import { render } from "./GridHeader.vue?vue&type=template&id=70fe9f55"
import script from "./GridHeader.vue?vue&type=script&lang=js"
export * from "./GridHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__